import gql from 'graphql-tag';

export const GET_ACCOUNTANT_INFO = gql`
  query AccountantInfo {
    accounting {
      accountantInfo {
        id
        userId
        firmId
        access
        firm {
          id
          name
          markets
        }
      }
    }
  }
`;

export const GET_ACCOUNTANT_COMPANIES = gql`
  query AccountantCompanies($marketId: Float, $pagination: PaginationInputType!, $search: String, $isAutopilotClient: Boolean) {
    accounting {
      accountantCompanies(marketId: $marketId, pagination: $pagination, search: $search, isAutopilotClient: $isAutopilotClient) {
        companies {
          email
          name
          id
          createdAt
          isAutopilotClient
          unreadFilesQty
          totalFilesQty
          userFirmCompanies {
            id
            userId
            companyId
            createdAt
            user {
              id
              email
            }
          }

        }
        limit
        offset
        total
      }
    }
  }
`;

export const GET_ACCOUNTANT_COMPANIES_COUNTS = gql`
  query AccountantCompanies($marketId: Float, $pagination: PaginationInputType!, $search: String, $isAutopilotClient: Boolean) {
    accounting {
      accountantCompanies(marketId: $marketId, pagination: $pagination, search: $search, isAutopilotClient: $isAutopilotClient) {
        companies {
          id
          unreadMessagesCount

        }
        limit
        offset
        total
      }
    }
  }
`;

export const GET_CHIEF_COMPANIES = gql`
  query chiefCompanies($pagination: PaginationInputType!, $accountantId: String, $marketId: Float, $search: String, $isAutopilotClient: Boolean) {
    accounting {
      chiefCompanies(pagination: $pagination, accountantId: $accountantId, marketId: $marketId, search: $search, isAutopilotClient: $isAutopilotClient) {
        companies {
          email
          name
          id
          createdAt
          isAutopilotClient
          unreadFilesQty
          totalFilesQty
          userFirmCompanies {
            user {
              id
              email
            }
          }

        }
        limit
        offset
        total
      }
    }
  }
`;
export const GET_CHIEF_COMPANIES_COUNTS = gql`
  query chiefCompanies($pagination: PaginationInputType!, $accountantId: String, $marketId: Float, $search: String, $isAutopilotClient: Boolean) {
    accounting {
      chiefCompanies(pagination: $pagination, accountantId: $accountantId, marketId: $marketId, search: $search, isAutopilotClient: $isAutopilotClient) {
        companies {
          id
          unreadMessagesCount

        }
        limit
        offset
        total
      }
    }
  }
`;
